import { render, staticRenderFns } from "./ServiceMachines.vue?vue&type=template&id=3b6f3be2&"
import script from "./ServiceMachines.vue?vue&type=script&lang=js&"
export * from "./ServiceMachines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports